module.exports = __webpack_public_path__ + "img/sub-accounts.b8988d66.svg";